import { useReturnStore } from '@src/stores/returnStore';
import React from 'react';
import ItemReturnMethod from './ItemReturnMethod';

interface SplitReturnMethodOptionsProps {
  showItemErrors?: boolean;
}

const SplitReturnMethodOptions = React.forwardRef<
  HTMLDivElement,
  SplitReturnMethodOptionsProps
>(({ showItemErrors = false }, ref) => {
  const selectedItems = useReturnStore((state) => state.selectedItems);
  return (
    <div ref={ref} className="sui-flex sui-flex-col sui-gap-[48px]">
      {selectedItems.map((item, index) => {
        return (
          <ItemReturnMethod
            key={index}
            item={item}
            showError={showItemErrors}
          />
        );
      })}
    </div>
  );
});

export default SplitReturnMethodOptions;
